import {Component, OnInit} from '@angular/core';
import {AngularFireAuth} from "@angular/fire/compat/auth";
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {first} from "rxjs/operators";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import firebase from "firebase/compat/app";
import UserCredential = firebase.auth.UserCredential;
import {ToastrService} from "ngx-toastr";
import {User} from "../dtos/user";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  errorMessage: string;
  loginForm = new UntypedFormGroup({
    email: new UntypedFormControl('', [
      Validators.required,
      Validators.email
    ]),
    password: new UntypedFormControl('', [
      Validators.required,
      Validators.minLength(8)
    ])
  });

  forgotPasswordEmail: string = '';
  sendingPasswordForgotRequest: boolean = false;
  private modalRef: NgbModalRef;
  modalError: string = '';

  constructor(
    private authService: AngularFireAuth,
    private router: Router,
    private db: AngularFirestore,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) {
  }

  ngOnInit() {
  }

  onSubmit() {
    this.errorMessage = '';
    this.loginForm.disable({});
    this.authService.signInWithEmailAndPassword(this.loginForm.value.email, this.loginForm.value.password)
      .then(
        (userCred) => this.onLoginSuccess(userCred),
        (error) => this.onLoginFailed(error)
      );
  }

  onLoginFailed(error: any) {
    this.errorMessage = error;
    this.loginForm.enable({});
    this.toastr.error("Aanmelden mislukt. Probeer opnieuw.");
  }

  onLoginSuccess(userCred: UserCredential) {
    this.db.collection<User>('users').doc(userCred.user.uid).get().pipe(
      first()
    ).subscribe(value => {
      this.toastr.success(`Welkom terug, ${value.data().displayName}`);
      this.router.navigate(['/recepten']);
    }, error => this.onLoginFailed(error));
  }

  signInWithGoogle() {
    this.authService.signInWithPopup(new firebase.auth.GoogleAuthProvider()).then(
      (userCred) => this.onLoginSuccess(userCred)
    ).catch((reason) => this.onLoginFailed(reason));
  }

  onPasswordResetClicked(content: String) {
    this.modalError = '';
    this.modalRef = this.modalService.open(content, {
      windowClass: 'dark-modal',
      beforeDismiss: () => {
        this.modalError = '';
        this.sendingPasswordForgotRequest = true;
        this.requestPasswordForgot(this.forgotPasswordEmail);
        return false;
      },
      keyboard: false
    });
  }

  requestPasswordForgot(email: string) {
    this.authService.sendPasswordResetEmail(email)
      .then(() => {
        this.toastr.success(
          'Wachtwoord reset verzonden',
          'We hebben je een email gestuurd. Volg de instructies in de mail om een nieuw wachtwoord in te stellen.'
        )
        this.modalRef.close();
      })
      .catch(reason => {
        this.modalError = 'Kon wachtwoord niet resetten. Ben je niet onder een ander email adres geregistreerd?';
        console.error("Could not send mail: " + reason);
      })
      .finally(() => {
        this.sendingPasswordForgotRequest = false;
      });
  }

}
